<template>
  <div>
    <b-modal
      id="abandon-meeting-modal"
      hide-footer
      centered
      size="lg"
      :title="meetingName"
    >
      <div class="d-flex align-items-center">
        <feather-icon
          size="20"
          icon="AlertTriangleIcon"
          class="text-danger mr-1"
        />
        <h4 class="mb-0 text-danger">Abandon Meeting</h4>
      </div>

      <p class="text-muted">
        You are about to abandon the entire {{ meetingName }} meeting. This
        action cannot be undone.
      </p>

      <div
        class="p-1 text-danger"
        style="
          background: #fdecec;
          border: 1px solid #f3bbbb;
          border-radius: 8px;
        "
      >
        <div class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="AlertTriangleIcon"
            class="text-danger mr-1"
          />
          <strong class="text-danger">Critical Warning</strong>
        </div>

        <p class="mb-0">Abandoning the entire meeting will:</p>
        <ul class="pl-2 mb-0">
          <li>Abandon all remaining races in the {{ meetingName }} meeting</li>
          <li>Cancel ALL active bets across all races and refund customers</li>
          <li>Stop all betting activity for the entire meeting</li>
          <li>Mark all races as abandoned</li>
          <li>Send mass notifications to all affected customers</li>
          <li>Trigger automatic refund processing</li>
        </ul>
      </div>

      <div class="d-flex justify-content-around text-center my-1 text-black">
        <div>
          <feather-icon size="20" icon="FlagIcon" />
          <h5 class="mb-0">{{ stats.racesAffected }}</h5>
          <small class="text-muted">Races Affected</small>
        </div>

        <div>
          <feather-icon size="20" icon="UsersIcon" />
          <h5 class="mb-0">{{ stats.totalBets }}</h5>
          <small class="text-muted">Total Bets</small>
        </div>

        <div>
          <feather-icon size="20" icon="DollarSignIcon" />
          <h5 class="mb-0">
            {{ formatCurrencyBuiltInFunc(stats.totalStakes) }}
          </h5>
          <small class="text-muted">Total Stakes</small>
        </div>

        <div>
          <feather-icon size="20" icon="AlertTriangleIcon" />
          <h5 class="mb-0">
            {{ formatCurrencyBuiltInFunc(stats.totalLiability) }}
          </h5>
          <small class="text-muted">Total Liability</small>
        </div>
      </div>

      <!-- FOOTER -->
      <div class="d-flex justify-content-end">
        <b-button
          variant="secondary"
          class="mr-2"
          @click="$bvModal.hide('abandon-meeting-modal')"
        >
          Cancel
        </b-button>

        <b-button variant="danger" @click="reviewMeeting">
          Review Races
        </b-button>
      </div>
    </b-modal>
    <ReviewAbandonMeetingModal @onFetchRaces="$emit('onFetchRaces')" />
  </div>
</template>
<script>
import { BModal, BButton } from "bootstrap-vue";
import { formatCurrencyBuiltInFunc } from "@/helpers/utils";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ReviewAbandonMeetingModal from "./ReviewAbandonMeetingModal.vue";
export default {
  components: {
    BModal,
    BButton,
    FeatherIcon,
    FeatherIcon,
    ReviewAbandonMeetingModal,
  },
  data() {
    return {
      meetingName: "Randwick",
      stats: {
        racesAffected: "7 of 9",
        totalBets: 182,
        totalStakes: 48700,
        totalLiability: 240700,
      },
    };
  },
  methods: {
    formatCurrencyBuiltInFunc,
    reviewMeeting() {
      this.$bvModal.hide("abandon-meeting-modal");
      this.$bvModal.show("review-abandon-meeting-modal");
    },
  },
};
</script>